import { useInfiniteQuery } from '@tanstack/react-query'
import { getGetRecentlyBoughtQueryKey, getRecentlyBought } from '@/apis/rest/generated/hooks'
import { GetRecentlyBoughtParams } from '@/apis/rest/generated/types'
import { UserContainer } from '@/containers/users/UserContainer'

export const useSearchRecentlyBought = ({ page = 1, size = 1, keyword = '사료' }: GetRecentlyBoughtParams) => {
  const { me } = UserContainer.useContainer()

  const {
    data,
    fetchNextPage,
    isLoading: isRecentlyBoughtProductsLoading,
  } = useInfiniteQuery(
    getGetRecentlyBoughtQueryKey({
      page,
      size,
      keyword,
    }),
    ({ pageParam = page }) => getRecentlyBought({ page: pageParam, size, keyword }),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.page.hasNextPage) {
          return lastPage.page.page + 1
        }
      },
      enabled: !!me,
    }
  )

  const recentlyBoughtProducts = data?.pages.map((page) => page.data).flat()

  return {
    data: recentlyBoughtProducts || [],
    fetchNextPage,
    isRecentlyBoughtProductsLoading,
  }
}
